<template>
  <div>
    <dashboard-cards ref="dashboardCards" useLocalPanels :extraParams="extraParams" :localPanels="localPanels" />
  </div>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import DashboardCards from '@Monitor/components/MonitorCard/DashboardCards'
import { SERVICE_MONITOR_OPTS, supportTabs } from '../constants'

export default {
  name: 'ServiceMonitorSidepage',
  components: {
    DashboardCards,
  },
  mixins: [WindowsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      service: this.data,
      singleActions: [],
    }
  },
  computed: {
    localPanels () {
      return SERVICE_MONITOR_OPTS.map(item => {
        return {
          panel_name: `${item.label}${item.metric ? `(${item.metric})` : `(${item.fromItem}.${item.seleteItem})`}`,
          constants: item,
          queryData: this.genQueryData(item),
        }
      })
    },
  },
  created () {
    this.$bus.$on('VmMonitorTypeChange', (tab) => {
      this.$refs.dashboardCards && this.$refs.dashboardCards.initMonitorConfig()
    })
  },
  methods: {
    genQueryData (val) {
      const opt = val
      const extraTags = val.extraTags ? [...val.extraTags] : []
      let select = []
      if (val.as) {
        const asItems = val.as.split(',')
        select = val.seleteItem.split(',').map((field, i) => {
          return [
            { type: 'field', params: [field] },
            { type: opt.groupFunc || opt.selectFunction || 'mean', params: [] },
            { type: 'alias', params: [asItems[i]] },
          ]
        })
      } else {
        select = val.seleteItem.split(',').map((field) => {
          return [
            { type: 'field', params: [field] },
            { type: opt.groupFunc || opt.selectFunction || 'mean', params: [] },
            { type: 'alias', params: [field] },
          ]
        })
      }
      const serviceName = this.service && this.service.name != null ? String(this.service.name) : ''
      const hit = serviceName ? supportTabs.find(item => item.name === serviceName) : null
      const serviceTypeRaw = hit && hit.alias != null ? String(hit.alias) : (this.service && this.service.type != null ? String(this.service.type) : '')
      const serviceType = serviceTypeRaw
      const escaped = serviceType.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const tags = [
        {
          key: 'service',
          value: `/^${escaped}$/`,
          operator: '=~',
        },
        ...extraTags,
      ]
      const model = {
        measurement: val.fromItem,
        select,
        tags,
      }
      if (val.groupBy && val.groupBy.length > 0) {
        model.group_by = []
        val.groupBy.forEach(group => {
          model.group_by.push({
            type: 'tag',
            params: [group],
          })
        })
      }
      return {
        metric_query: [
          {
            model,
          },
        ],
        scope: this.$store.getters.scope,
        unit: true,
        skip_check_series: true,
      }
    },
  },
}
</script>
